import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class OmittedExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.OmittedExpression;
    }
    visitNode(_sb, _expr, _options) {
    }
}

//# sourceMappingURL=OmittedExpressionCompiler.js.map
